module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-view', [_c('c-page', [_c('c-content', [_c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('c-msg', {
    attrs: {
      "title": "恭喜您，注册成功",
      "desc": _vm.desc.join('<br>')
    }
  }, [_c('c-button', {
    nativeOn: {
      "click": function($event) {
        _vm.downloadApp($event)
      }
    }
  }, [_vm._v("\n          下载生意专家手机端\n        ")])], 1), _vm._v(" "), _c('info-footer')], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-407517c8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/signup-status/index.vue
// module id = 361
// module chunks = 0